import { LogicalFieldMixin } from './mixins.js';
import { OptionableMixin } from './optionable.js';

const LogicalCheckBox = {
  mixins: [LogicalFieldMixin, OptionableMixin],

  created: function() {
    this.optionIcon = 'slp-square-o';
  }
};

export default LogicalCheckBox;
